import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'

import { Grid, Row, Col, ControlLabel, FormControl, Button } from 'react-bootstrap'

import getServerURL from '../../../functions/getServerURL'

import '../style.css'

class ChangePasswordContainer extends Component {

  state = {
    error: '',
    old_password: '',
    new_password: '',
    confirm_new_password: '',
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleEnterPress)
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleEnterPress)
  }

  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSubmitPasswordChange()
    }
  }


  handleChange = (e) => this.setState({[e.target.name]: e.target.value})

  handleSubmitPasswordChange = () => {
    const {old_password, new_password, confirm_new_password } = this.state

    let error = ''

    if (!old_password) {
      error = "Please enter your current password"
    }

    if (!new_password || !confirm_new_password) {
      error = "Please enter and confirm a new password"
    }

    if (new_password.length < 8 || confirm_new_password.length < 8) {
      error = "Passwords must be at least 8 characters in length"
    }

    if (new_password !== confirm_new_password) {
      error = "New passwords do not match"
    }

    if (error) {
      return this.setState({ error })
    }

    this.setState({ error: null })
    axios({
      method:"PUT",
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
      url: `${getServerURL()}change-password/`,
      data: {
        username: this.props.currentUser.username,
        old_password,
        new_password,
      }
    })
    .then(response => {
      this.props.history.push('/')
    })
    .catch(error => {
      const data = error.response.data
      if (data.old_password) {
        return this.setState({ error: data.old_password.join(' ') })
      } else if (data.new_password) {
        const errorMessage = data.new_password.join(' ')
        return this.setState({ error: `There was an error updating your password: ${errorMessage}`})
      }
    })
  }

  render() {
    return(
      <div id="ChangePasswordContainer">
        <Grid>
          <Row>
            <Col xsHidden md={4}></Col>
            <Col xs={12} md={4}>
              <br/>
              <div className="error-field">
                {this.state.error}
              </div>
              <div id="username-field">
                <ControlLabel>Username</ControlLabel>
                <FormControl
                  disabled
                  label="Username"
                  placeholder="Enter username"
                  value={this.props.currentUser.username}
                  onChange={() => null}
                />
              </div>
              <br/>
              <ControlLabel>Old Password</ControlLabel>
              <FormControl
                type="password"
                name="old_password"
                placeholder="Enter old password"
                value={this.state.old_password}
                onChange={this.handleChange}
              />
              <br/>
              <ControlLabel>New Password</ControlLabel>
              <FormControl
                data-private
                type="password"
                name="new_password"
                placeholder="Enter new password"
                value={this.state.new_password}
                onChange={this.handleChange}
              />
              <br/>
              <ControlLabel>Confirm New Password</ControlLabel>
              <FormControl
                data-private
                type="password"
                name="confirm_new_password"
                placeholder="Confirm new password"
                value={this.state.confirm_new_password}
                onChange={this.handleChange}
              />
              <br/>
              <div id="login-button">
              <Button onClick={this.handleSubmitPasswordChange}>
                Change Password
              </Button>
              </div>
            </Col>
            <Col xsHidden md={4}></Col>
          </Row>
        </Grid>
      </div>
    )
  }
}



const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps)(ChangePasswordContainer)



// WEBPACK FOOTER //
// ./src/routes/user-settings/components/ChangePassword.js